import { useState } from 'react';

import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { PasswordField } from '@components/password-field';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';

import { api } from 'api';

import { useAuthenticatedUser } from 'features/authentication';
import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

export const AddAuthenticator = observer(({ qrCodeUrl, enable, closeModal }) => {
  const { t, userStore } = useStore();
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [code, setCode] = useState('');
  const [codeError, setCodeError] = useState('');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const me = useAuthenticatedUser();

  async function checkPassword() {
    setLoading(true);
    const res = await api.authentication.checkPassword(me.email, password);
    if (res.error) {
      setPasswordError(t('modals.addauthenticator.password.error'));
    } else {
      setStep(2);
    }
    setLoading(false);
  }

  async function onSubmit() {
    if (code === '') {
      setCodeError(t('modals.addauthenticator.code.required'));
    } else {
      setLoading(true);
      const res = await userStore.addAuthenticator(password, code);
      if (res.error) {
        if (res.data.device) {
          setCodeError(t('modals.addauthenticator.code.error'));
        }
      } else {
        enable();
        setStep(3);
      }
      setLoading(false);
    }
  }
  return (
    <Modal>
      {step === 1 && (
        <>
          <Modal.Header text={t('modals.addauthenticator.header')} />
          <Stack space={4}>
            <Text text={t('modals.addauthenticator.subheader')} />
            <PasswordField
              label={t('modals.addauthenticator.password.label')}
              value={password}
              onChange={setPassword}
              error={
                passwordError &&
                passwordError.split('\n').map((item, i) => <div key={i}>{item}</div>)
              }
            />
          </Stack>
          <Modal.Actions>
            <Button
              isDisabled={loading}
              variant="secondary"
              onClick={closeModal}
              text={t('modals.addauthenticator.button.cancel')}
            />
            <Button
              isDisabled={loading}
              onClick={checkPassword}
              text={t('modals.addauthenticator.button.submit')}
            />
          </Modal.Actions>
        </>
      )}
      {step === 2 && (
        <>
          <Modal.Header text={t('modals.addauthenticator.header')} />
          <Stack space={4}>
            <Text text={t('modals.addauthenticator.qrcode.helptext')} />
            <img alt={'qrcode'} style={{ width: '50%' }} src={qrCodeUrl} />
            <Text text={t('modals.addauthenticator.code.helptext')} />
            <TextField
              label={t('modals.addauthenticator.code.label')}
              value={code}
              onChange={setCode}
              error={codeError && codeError.split('\n').map((item, i) => <div key={i}>{item}</div>)}
            />
          </Stack>

          <Modal.Actions>
            <Button
              isDisabled={loading}
              variant="secondary"
              onClick={closeModal}
              text={t('modals.addauthenticator.button.cancel')}
            />
            <Button
              isDisabled={loading}
              onClick={onSubmit}
              text={t('modals.addauthenticator.button.submit')}
            />
          </Modal.Actions>
        </>
      )}
      {step === 3 && (
        <>
          <Modal.Header text={t('modals.addauthenticator.header.success')} />
          <Stack space={4}>
            <Text text={t('modals.addauthenticator.subheader.success')} />
          </Stack>

          <Modal.Actions>
            <Button onClick={closeModal} text={t('modals.addauthenticator.button.submit')} />
          </Modal.Actions>
        </>
      )}
    </Modal>
  );
});
